/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useLanguage } from '@/providers/LanguageProvider';

import { CustomButton } from '../common';
import { Icons } from '../icons';
import { WorkflowDiscoverySection } from './workflow-discovery-section';

interface OnboardingMesageProps {
  locale: string;
  showExamples: boolean;
}

export const OnboardingMesage: React.FC<OnboardingMesageProps> = ({
  locale,
  showExamples,
}) => {
  const { messages } = useLanguage();
  const router = useRouter();

  return (
    <div className="mt-2.5 rounded-[4px] border border-form-control-border-disabled p-6">
      <div className="flex w-full flex-col items-center justify-center text-center">
        {Icons.RocketIcon('size-12 text-form-input-disabled opacity-[48%]')}
        <h3 className="mt-4 text-h2 text-body-primary">
          {messages?.DashboardPage.add_first_app}
        </h3>
        <p className="mt-1 text-form-input-text text-form-input-disabled">
          {messages?.DashboardPage.get_started}
        </p>
        <div className="mt-6">
          <CustomButton
            id="step-2"
            customVariant="primary"
            customSize="regular"
            className="flex h-[42px] items-center gap-1 rounded-[2px] bg-fill-button-rest px-4 py-1.5 text-btn-label text-body-primary"
            onClick={() => router.push(`/${locale}/apps/new-app`)}
          >
            <Image
              src="/shared-icons/Add.svg"
              width={16}
              height={16}
              alt="Add Icon"
            />
            {messages?.DashboardPage?.new_app_onboarding}
          </CustomButton>
        </div>
      </div>

      {/* separator */}
      <div className="my-8 flex items-center gap-4">
        <span className="h-px flex-1 bg-line-tertiary" />
        <span className="text-form-input-text text-form-input-disabled">
          {messages?.General?.or}
        </span>
        <span className="h-px flex-1 bg-line-tertiary" />
      </div>

      {/* workflow-discovery experience */}
      <WorkflowDiscoverySection showExamples={showExamples} />
    </div>
  );
};
